<template>
    <div class="game-card col-3 p-2">
        <!-- Game Image & Buttons -->
        <div class="game-image position-relative">
            <div @click="handlePlay">
                <SkeletonImage
                    :src="imageLinkGenerate(game.gameID, game.provider)"
                    alt="Game Card"
                    class="h-100 w-100"
                />
            </div>
            

            <!-- Play Button -->
            <!-- <div
                class="play-btn"
                @click="handlePlay"
            >
                Play
            </div> -->

            <!-- Player Count -->
            <!-- <div class="player-count">
                <i class="fas fa-users"></i>
                {{ game.playerCount }}
            </div> -->

            <!-- Save Button -->
            <div
                class="save-btn"
                @click.stop="game.is_favorite ? removeFromWishList() : addToWishList()"
                :class="game.is_favorite ? 'text-danger' : 'text-muted'"
            >
                <i class="fas fa-heart-circle-plus" v-if="!game.is_favorite"></i>
                <i class="fas fa-heart" v-else></i>
            </div>
        </div>

        <!-- Game Info -->
        <div
            style="cursor: pointer;"
            @click="handlePlay"
        >
            <p
                class="mb-0 text-uppercase text-center text-ellipsis"
                style="font-size: .7rem; color: #ccc !important;"
            >
                {{ game.gameName }}
            </p>
            <p
                class="text-center text-uppercase text-muted text-ellipsis font-weight-bold"
                style="line-height: 1; color: #fff !important;"
            >
                <small>{{ provider }}</small>
            </p>
        </div>
    </div>
</template>

<script>
import SkeletonImage from './SkeletonImage.vue';
import { Toast } from 'vant';

export default {
    components: {
        SkeletonImage
    },

    props: {
        game: {
            type: Object,
            required: true
        },
        provider: {
            type: String,
            default: ""
        }
    },
    methods: {
        async addToWishList() {
            try {
                if(!this.$store.state.authUser.phone){
                    return this.$router.push('/auth/login');
                }
                this.$store.commit('setLoading', true);
                const res = await axios.post('/add_to_wish_list', {
                    game_id: this.game.id
                },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('token')}`,
                        },
                    });
                this.game.is_favorite = true;
                Toast.success("Added!");
                this.$emit("toggle-favorite", this.game);
                this.$store.commit('setLoading', false);
            } catch (error) {
                console.log(error);
                Toast.fail("Fail!");
                this.$store.commit('setLoading', false);
            }
        },
        async removeFromWishList() {
            try {
                if(!this.$store.state.authUser.phone){
                    return this.$router.push('/auth/login');
                }
                this.$store.commit('setLoading', true);
                const res = await axios.post('/remove_from_wish_list', {
                    game_id: this.game.id
                }, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                    },
                });
                this.game.is_favorite = false;
                Toast.success("Removed!");
                this.$emit("toggle-favorite", this.game);
                this.$store.commit('setLoading', false);
            } catch (error) {
                console.log(error);
                Toast.fail("Fail!");
                this.$store.commit('setLoading', false);
            }
        },
        // Toggle favorite state
        toggleFavorite() {
            this.$emit("toggle-favorite", this.game);
        },

        // Handle play logic
        handlePlay() {
            console.log('hello')
            this.$emit('handle-play', this.game)
        },

        // Generate Image Link
        imageLinkGenerate(gameId, type) {
            if (type === 'Jili') {
				return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/jili/${gameId}.webp`;
			} if (type === 'Rich88') {
				return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/rich88/${gameId}.webp`;
			}if (type === 'Live22') {
				return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/live22/${gameId}.webp`;
			} if (type === 'Spade') {
				return `https://merchantapi.silverkirin88.com/thumbnail/en_US/${gameId}.jpg`;
			} if (type === 'Fastspin') {
				return `http://api-egame-staging.fsuat.com/thumbnail/en_US/${gameId}.jpg`;
			} if (type === 'Playstar') {
				return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/playstar/${gameId}.webp`;
			} if (type === 'FaChai') {
				return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/fachai/${gameId}.webp`;
			} if (type === 'PGSoft') {
				return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/pgsoft/pgsoft_${gameId}.webp`;
			} if (type === 'JOKER' || type === 'Joker') {
				return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/joker/${gameId}.webp`;
			} if (type === '5G') {
				return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/5g/${gameId}.webp`;
			} if (type === 'KA') {
				return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/newKA/${gameId}.webp`;
			} if (type === 'AceWin') {
				return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/acewin/${gameId}_EN.webp`;
			} if (type === 'JDB') {
				return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/jdb/${gameId}.webp`;
			} if (type === 'HotDog') {
				return `https://res.hotdog-gaming.com/banners/380x500/${gameId}.png`;
			} if (type === 'Rich') {
				return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/rich/${gameId}.webp`;
			} if (type === 'CQ9' || type === 'cq9' || type === 'SexySlot') {
				return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/cq9/cq9_${gameId}.webp`;
			} if (type === 'BTG') {
				return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/btg/${gameId}.webp`;
			} if (type === 'BNG') {
                return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/bng/${gameId}.webp`;
            } if (type === 'AFGame') {
				return `https://cdn.myanmarshankoeme.com/build/assets/img/AFG-Square/${gameId}.webp`;
			} if (type === '2J') {
				return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/2j/${gameId}.webp`;
			} if (type === 'VA') {
				return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/va/${gameId}_en.webp`;
			} if (type === 'Buffalo') {
				return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/afb/${gameId}.webp`;
			}

			return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/pp/${gameId}.webp`;

        },
    }
};
</script>

<style scoped>
.save-btn {
    cursor: pointer;
    font-size: 1.1rem;
    position: absolute;
    /* top: 0;
    right: 0; */
    top: -8px;
    right: -7px;
    background: rgba(0, 0, 0, .6);
    padding: 1rem;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.play-btn {
    cursor: pointer;
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);

    background: #d4c23f;
    color: black;
    border-radius: 20px;
    border: 0;
    padding: 4px 1.5rem;
    font-size: 0.7rem;
    text-align: center;
    box-shadow: none;
}

.player-count {
    font-size: 0.7rem;
    font-weight: bold;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, .6);
    color: #fff;
    padding: 2px 4px;
    display: flex;
    align-items: center;
    gap: 4px;
    width: 100%;
    justify-content: center;

    i {
        color: rgb(17, 255, 17);
        transition: .3s cubic-bezier(.25, .8, .5, 1), visibility 0s;
        animation: blinker .8s linear infinite;
    }
}

@keyframes blinker {
    50% {
        opacity: .4;
    }
}
</style>
